import { db } from './firebase';
import {
  collection, getDocs, query, orderBy, limit, where, Timestamp,
} from 'firebase/firestore';

export async function getSignInLogs({ days = 30, maxResults = 500 } = {}) {
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - days);
  const snap = await getDocs(
    query(
      collection(db, 'signInLogs'),
      where('timestamp', '>=', Timestamp.fromDate(cutoff)),
      orderBy('timestamp', 'desc'),
      limit(maxResults),
    ),
  );
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
